import { useMemo } from 'react';

import { CustomMatchListColumnsOperationQuery } from 'core/graphql';
import { useQuery } from 'shared/hooks';
import {
  CUSTOM_MATCH_LIST_COLUMNS_QUERY,
  getColumnLabels,
} from 'shared/utils/targetColumn';

export const useTargetColumns = () => {
  const { loading, data } = useQuery<CustomMatchListColumnsOperationQuery>(
    CUSTOM_MATCH_LIST_COLUMNS_QUERY
  );

  const columns = data?.customMatchListColumns;
  const columnsLimit = data?.customMatchListColumnLimit;

  const columnsSorted = useMemo(
    () =>
      columns !== undefined
        ? [...columns].sort((a, b) => a.name.localeCompare(b.name))
        : [],
    [columns]
  );
  const total = columnsSorted.length;
  const hasReachedLimit =
    !!columnsLimit && !!total && total / columnsLimit >= 1;

  const targetColumnLabels = getColumnLabels(columnsSorted);

  return {
    loading,
    customColumns: columnsSorted,
    customColumnsTotal: total,
    customColumnsLimit: columnsLimit,
    hasReachedLimit,
    targetColumnLabels,
  };
};
